import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { ChevronDownIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import { SidebarItemType } from './sidebar-item'

type SidebarToggleItemProps = {
  mode?: 'expanded' | 'collapsed'
  variant: 'thick-padding' | 'thin-padding'
  item: SidebarItemType
  isActive: boolean
  isExpanded: boolean
}

const SidebarToggleItem: React.FC<SidebarToggleItemProps> = ({
  mode = 'expanded',
  item,
  isActive,
  variant,
  isExpanded
}) => {
  const { text, icon: Icon, isIconFilled, items } = item
  return (
    <>
      <div
        className={cn('flex items-center space-x-2', {
          'ml-2': variant === 'thin-padding'
        })}
      >
        {Icon && (
          <Icon
            className="flex-shrink-0"
            color={tailwindColors.white.DEFAULT}
            fill={isIconFilled ? tailwindColors.white.DEFAULT : 'none'}
            filled={isIconFilled}
          />
        )}

        {!Icon && items && items.length > 0 && (
          <div
            className={cn('transform transition-transform flex-shrink-0', {
              'rotate-180': isExpanded
            })}
          >
            <ChevronDownIcon width="16px" height="16px" />
          </div>
        )}

        {(!items || items.length === 0) && !Icon && (
          <div
            className={cn('bg-white w-2 h-2 rounded-full aspect-square flex-shrink-0', {
              hidden: mode === 'collapsed'
            })}
          />
        )}

        <Typography
          variant="secondary-body"
          className={cn('max-w-full', {
            'text-white': isActive,
            'text-primary-light': !isActive,
            hidden: mode === 'collapsed'
          })}
          style={isActive ? { fontWeight: 700 } : { fontWeight: 400 }}
        >
          {text}
        </Typography>
      </div>
      {mode === 'expanded' && Icon && items && items.length > 0 && (
        <div
          className={cn('transform transition-transform flex-shrink-0', {
            'rotate-180': isExpanded
          })}
        >
          <ChevronDownIcon width="16px" height="16px" />
        </div>
      )}
    </>
  )
}

export default SidebarToggleItem
